import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { firstValueFrom, catchError, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Utils } from '@services/utils.service';
import { Service as ServiceStorage } from '@services/storage.service';

@Injectable({ providedIn: 'root' })
export class Service {
    private Translation: any = {};
    private uuid!: string;

    constructor(
        private Utils: Utils,
        private Router: Router,
        private HttpClient: HttpClient,
        private TranslateService: TranslateService,
        private ServiceStorage: ServiceStorage
    ) {
        this.loadUUID();
        this.TranslateService.get(['ERRORS', 'SUCCESS', 'BUTTONS']).subscribe((Translation: string) => { this.Translation = Translation; });
    }

    async loadUUID() {
        this.uuid = await this.getUUID();
    }

    async fetch(data: any, url: string, type: 'get' | 'post' | 'formdata' | 'delete' | 'put' | 'download'): Promise<any> {
        const token = await this.ServiceStorage.get('token');
        const jsonwebtoken = await this.ServiceStorage.get('jsonwebtoken');
        const headers = { Authorization: `Bearer ${jsonwebtoken}` };

        if (data instanceof FormData) {
            data.set('uuid', await this.getUUID());
            
            if (!data.get('token')) {
                data.set('token', token);
            }
        } else {
            if (!data['token']) {
                data['token'] = await this.ServiceStorage.get('token');
            }

            data['uuid'] = await this.getUUID();
        }


        let return_data: any = { success: 0, data: null, error: '', reason: '' };

        let promise = new Promise<any>(async (resolve, reject) => {
            const observer = {
                next: (return_data: any) => {
                    if (return_data.error !== undefined && return_data.error === 'APP_STATUS_OFFLINE') {
                        this.Router.navigate(['/app_status/offline']);
                    } else if (return_data.error === 'NOT_SAME_AGENT' || return_data.error === 'NOT_SAME_UUID' || return_data.error === 'NOT_SAME_REMOTE_IP') {
                        this.logout();
                    }

                    resolve(return_data);
                },
                error: (error: any) => {
                    return_data.error = 'error';
                    return_data.reason = error;
                    resolve(return_data);
                },
                complete: () => {
                    // Handle any cleanup or additional actions here if needed
                }
            };

            switch (type) {
                case 'post':
                    this.HttpClient.post(url, data).subscribe(observer);
                    break;

                case 'get':
                    this.get(data, url, true).subscribe(observer);
                    break;

                case 'put':
                    this.HttpClient.put(url, data).subscribe(observer);
                    break;

                case 'delete':
                    this.HttpClient.delete(url, { params: data }).subscribe(observer);
                    break;

                case 'formdata':
                    let newFormData: FormData;

                    if (data instanceof FormData) {
                        newFormData = data;
                        /*if (!data.hasOwnProperty('token') || data.get('token') === null || data.get('token') === undefined) {
                            newFormData.append('token', await this.ServiceStorage.get('token'));
                        }*/
                    } else {
                        newFormData = new FormData();

                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                newFormData.append(key, data[key]);
                            }
                        }
                    }

                    this.HttpClient.post(url, newFormData, { headers }).subscribe(observer);
                    break;

                case 'download':
                    data.token = await this.ServiceStorage.get('token');

                    this.get(data, url, true, true).subscribe({
                        next: (blob: Blob) => resolve(blob),
                        error: (error: any) => {
                            return_data.error = 'error';
                            return_data.reason = error;
                            resolve(return_data);
                        }
                    });
                    break;

                default:
                    resolve(return_data);
                    break;
            }
        });

        return await promise;
    }

    get(data: any, url: string, list?: boolean, download?: boolean): any {
        if (list) {
            if (download) {
                return this.HttpClient.get(url, { params: data, responseType: 'blob', observe: 'body' });
            }

            return this.HttpClient.get(url, { params: data });
        } else {
            let data_string = '';

            for (let value in data) {
                if (value != 'url') {
                    data_string += '/' + data[value];
                }
            }

            return this.HttpClient.get(url + data_string);
        }
    }

    async logout() {
        await this.Utils.showSpiner();

        await this.ServiceStorage.remove('role');
        await this.ServiceStorage.remove('token');
        await this.ServiceStorage.remove('user');
        await this.ServiceStorage.remove('login_status');
        await this.ServiceStorage.remove('authenticated');

        // this.Router.navigateByUrl('/');
        this.Router.navigate(['/']);
        await this.Utils.closeSpiner();
    }

    async getUUID(renew: boolean = false) {
        let uuid = await this.ServiceStorage.get('uuid');

        if (!uuid || renew) {
            uuid = this.Utils.getUUID();
            await this.ServiceStorage.set('uuid', uuid);
        }

        return uuid;
    }
}




// // src/app/services/backend-api.service.ts
// import { Injectable } from '@angular/core';
// import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
// import { Observable, of, throwError, from } from 'rxjs';
// import { map, catchError, timeout, retryWhen, scan, delay, switchMap, tap, shareReplay } from 'rxjs/operators';
// import { ServiceStorage } from './storage.service';
// import { Utils } from './utils.service';

// export interface ApiResponse<T = any> {
//     success: number;
//     data?: T | null;
//     error?: string;
//     reason?: any;
//     [k: string]: any;
// }

// const DEFAULT_TIMEOUT = 30000; // 30s
// const MAX_RETRIES = 2;

// @Injectable({ providedIn: 'root' })
// export class BackendApiService {
//     constructor(
//         private http: HttpClient,
//         private storage: ServiceStorage,
//         private utils: Utils
//     ) { }

//     // Helper: unified error map
//     private handleError(err: any) {
//         const error = {
//             success: 0,
//             error: err?.error?.error ?? 'ERROR_UNKNOWN',
//             reason: err?.error?.reason ?? err?.message ?? err,
//         };
//         return of(error as ApiResponse);
//     }

//     // Helper: retry strategy with exponential backoff
//     private retryStrategy<T>() {
//         return retryWhen((errors) =>
//             errors.pipe(
//                 scan((acc, error) => {
//                     if (acc >= MAX_RETRIES) {
//                         throw error;
//                     }
//                     return acc + 1;
//                 }, 0),
//                 delay((retryCount) => 300 * Math.pow(2, retryCount)) // exponential backoff
//             )
//         );
//     }

//     // Build full url
//     private url(path: string, fullPath = false): string {
//         return fullPath ? path : `${environment.api}${path}`;
//     }

//     // GET with params
//     public get<T = any>(path: string, params?: any, fullPath = false, options: { cache?: boolean, timeoutMs?: number } = {}): Observable<ApiResponse<T>> {
//         const requestUrl = this.url(path, fullPath);
//         let httpParams = new HttpParams();
//         if (params) {
//             Object.keys(params).forEach(k => {
//                 if (params[k] !== undefined && params[k] !== null) {
//                     httpParams = httpParams.set(k, params[k]);
//                 }
//             });
//         }

//         const observable = this.http.get<ApiResponse<T>>(requestUrl, { params: httpParams }).pipe(
//             timeout(options.timeoutMs ?? DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );

//         // allow cheap caching for GET if requested
//         return options.cache ? (observable.pipe(shareReplay(1))) : observable;
//     }

//     // Simple GET building url path segments (like old logic)
//     public getByPath<T = any>(path: string, segments: any[] = [], fullPath = false): Observable<ApiResponse<T>> {
//         const seg = segments.map(String).map(s => encodeURIComponent(s)).join('/');
//         const requestUrl = this.url(path + (seg ? `/${seg}` : ''), fullPath);
//         return this.http.get<ApiResponse<T>>(requestUrl).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );
//     }

//     // POST JSON
//     public post<T = any>(path: string, body: any = {}, fullPath = false): Observable<ApiResponse<T>> {
//         const requestUrl = this.url(path, fullPath);
//         return this.http.post<ApiResponse<T>>(requestUrl, body).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );
//     }

//     // PUT
//     public put<T = any>(path: string, body: any = {}, fullPath = false): Observable<ApiResponse<T>> {
//         const requestUrl = this.url(path, fullPath);
//         return this.http.put<ApiResponse<T>>(requestUrl, body).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );
//     }

//     // DELETE with params
//     public delete<T = any>(path: string, params: any = {}, fullPath = false): Observable<ApiResponse<T>> {
//         const requestUrl = this.url(path, fullPath);
//         let httpParams = new HttpParams();
//         if (params) {
//             Object.keys(params).forEach(k => {
//                 if (params[k] !== undefined && params[k] !== null) {
//                     httpParams = httpParams.set(k, params[k]);
//                 }
//             });
//         }
//         return this.http.delete<ApiResponse<T>>(requestUrl, { params: httpParams }).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );
//     }

//     // FORM-DATA POST
//     public postForm<T = any>(path: string, data: FormData | Record<string, any>, fullPath = false): Observable<ApiResponse<T>> {
//         const requestUrl = this.url(path, fullPath);
//         let payload: FormData;

//         if (data instanceof FormData) {
//             payload = data;
//         } else {
//             payload = new FormData();
//             Object.keys(data || {}).forEach(k => {
//                 if (data[k] !== undefined && data[k] !== null) {
//                     payload.append(k, data[k]);
//                 }
//             });
//         }

//         return this.http.post<ApiResponse<T>>(requestUrl, payload).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => this.handleError(err))
//         );
//     }

//     // DOWNLOAD (blob)
//     public download(path: string, params: any = {}, fullPath = false): Observable<Blob> {
//         const requestUrl = this.url(path, fullPath);
//         let httpParams = new HttpParams();
//         Object.keys(params || {}).forEach(k => {
//             if (params[k] !== undefined && params[k] !== null) {
//                 httpParams = httpParams.set(k, params[k]);
//             }
//         });

//         return this.http.get(requestUrl, { params: httpParams, responseType: 'blob' }).pipe(
//             timeout(DEFAULT_TIMEOUT),
//             this.retryStrategy(),
//             catchError(err => { throw err; })
//         );
//     }

//     // Convenience: call and return Promise (if you prefer async/await)
//     public toPromise<T = any>(obs: Observable<ApiResponse<T>>) {
//         return obs.pipe(take(1)).toPromise();
//     }
// }
